/**
 * @GENERATED from Figma node 3608:50993
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ClubhouseDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#6515DD"
      d="M20.334 1.999H3.667C2.747 1.999 2 2.745 2 3.665v16.667c0 .92.747 1.666 1.667 1.666h16.667c.92 0 1.666-.746 1.666-1.666V3.665c0-.92-.746-1.666-1.666-1.666"
    />
    <path
      fill="#fff"
      d="M6.723 15.017a.9.9 0 0 0 0 1.796.898.898 0 1 0 0-1.796M17.764 7.186l-5.648 1.8V7.204l-6.09 1.944v5.163l5.25-1.675v1.773l6.905-2.206-1.87-1.827zm-6.488 4.566-4.411 1.407V9.764l4.411-1.406zm5.342.07-4.504 1.435v-3.39l4.15-1.327-.95 2.006z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(ClubhouseDark);
export { ForwardRef as ClubhouseDark };
